<template>
  <v-card flat tile>
    <v-container>
    <v-subheader>缴费记录</v-subheader>
    <l-data-card
      class="mb-5"
      flat
      :get-data="getUserBillList"
      :headers="header_use"
      :auto-title="0"
      :auto-headers="0"
      auto-actions
      hide-title-search
      :init-pagination="{sortBy: 'creationTime', descending: true}"
      no-data-text="没有缴费记录"
    >
      <template slot="item-action" slot-scope="{props}">
        <v-layout justify-center>
          <v-btn color="primary" flat @click="goToBillDetails(props.item)">点击查看账单详情</v-btn>
        </v-layout>
      </template>
    </l-data-card>
    <v-subheader>充值记录</v-subheader>
    <l-data-card
      class="mb-5"
      flat
      :get-data="getUserPayList"
      :headers="header_pay"
      :auto-title="0"
      :auto-headers="0"
      auto-actions
      hide-title-search
      :init-pagination="{sortBy: 'creationTime', descending: true}"
      no-data-text="没有充值"
    ></l-data-card>
    </v-container>
  </v-card>
</template>

<script>
import LDataCard from '@/components/LDataCard'
export default {
  name: 'purseUseDetail',
  components: {
    LDataCard
  },
  data () {
    return {
      header_use: [
        {text: '创建时间', value: 'creationTime', sortable: false, align: 'left', f: (v) => (this.$L.time.stringify(v))},
        {text: '支付金额', value: 'payAmount', sortable: true, align: 'left'},
        {text: '支付时间', value: 'payTime', sortable: false, align: 'left'},
      ],
      header_pay: [
        {text: '创建时间', value: 'creationTime', sortable: false, align: 'left', f: (v) => (this.$L.time.stringify(v))},
        {text: '充值金额', value: 'rechAmount', sortable: true, align: 'left', f: (v) => (v / 100 + '元')},
        {text: '充值时间', value: 'rechTime', sortable: false, align: 'left', f: (v) => (this.$L.time.stringify(v))},
        {text: '充值方式', value: 'rechMode', sortable: false, align: 'left'}
      ],
    }
  },
  methods: {
    async getUserBillList ({pagination, sortStack, filterItems = [], search}) {
      try {
        let p = await this.$store.dispatch('login/getSelfInfo')
        let {items, amount} = await this.$store.dispatch('pay/getUserBillList', {pagination, sortStack, filter: filterItems, search: {key: 'userId', value: p.id}})
        return {items: items, amount: amount}
      }
      catch (e) {

      }
    },
    async getUserPayList ({pagination, sortStack, filterItems = [], search}) {
      try {
        let p = await this.$store.dispatch('login/getSelfInfo')
        let {items, amount} = await this.$store.dispatch('pay/getUserPayList', {pagination, sortStack, filter: filterItems, search: {key: 'userId', value: p.id}})
        // console.log(items)
        return {items: items, amount: amount}
      }
      catch (e) {

      }
    },
    goToBillDetails (data) {
      this.$router.push({name: 'billDetailsWx',
        query: {
          billId: data.billId
        }})
    },
  },
  created () {

  }
}
</script>

<style scoped>

</style>
